import styled from 'styled-components';
import { Avatar } from '@pearsontechnology/aero-components';

export const AvatarWrapper = styled(Avatar)`
  cursor: pointer;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
